import React from "react";

function Contact() {
  return (
    <div className="rounded-xl bg-white p-6 md:p-10 shadow-sm border border-gray-100 min-h-[calc(100vh-8rem)]">
      <div className="max-w-3xl text-sm text-gray-600 leading-relaxed">
        <h2 className="text-2xl font-light text-gray-800 mb-6">Contact</h2>
        <p>
          ALTRUIST builds on the variometric algorithms developed at the Geodesy and Geomatics Division
          of Sapienza University of Rome, where the project originated. It is now led from Géoazur
          (Observatoire de la Côte d’Azur, Université Côte d’Azur), in collaboration with Sapienza
          University of Rome.
        </p>

        <div className="mt-8 rounded-lg border border-gray-100 bg-gray-50 p-5">
          <p className="text-base font-semibold text-gray-800">Michela Ravanelli</p>
          <p className="text-brand-500 font-medium">Principal Investigator</p>
          <p className="mt-2">Junior Research Director (Chaire de professeur junior)</p>
          <p>Laboratoire Géoazur – Observatoire de la Côte d’Azur, Université Côte d’Azur</p>
          <p>250 rue Albert Einstein, 06560 Valbonne, France</p>
          <p className="mt-3">
            <span aria-hidden="true">✉ </span>
            <a href="mailto:michela.ravanelli@geoazur.unice.fr" className="text-brand-500 hover:underline">
              michela.ravanelli@geoazur.unice.fr
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
